import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/ContentBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/ContentWithImageBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/ContentWithLinksBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/facts/AgeStructureBox.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/facts/ChartBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/facts/Facts2020.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/facts/icons/databox.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/facts/icons/revenue_icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/facts/SmallNumberBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/IconContentBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/IntroBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/RevenueBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/SlideshowBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/StoryBlockToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/TitleBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/blocks/VideoAnimationBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/app/[locale]/[year]/SubMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/stories/src/components/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Vimeo"] */ "/vercel/path0/packages/helper/Vimeo/index.tsx");
